/**
 * tableToTsv — flatten a rendered HTML table into tab-separated values.
 *
 * Reads the DOM rows/cells (not the markdown source), so it works for any
 * GFM table the Markdown renderer produced and pastes cleanly into
 * spreadsheets. Ported from the unified chat one-off (PQA#2641) as part of
 * the table-treatment consolidation; exported for consumers that build their
 * own copy affordances around tables.
 */
export function tableToTsv(table: HTMLTableElement): string {
  return Array.from(table.rows)
    .map(row =>
      Array.from(row.cells)
        .map(cell => (cell.textContent ?? "").trim())
        .join("\t"),
    )
    .join("\n");
}
